import { render, staticRenderFns } from "./InquiryMessageModal.vue?vue&type=template&id=27fd0226&"
import script from "./InquiryMessageModal.vue?vue&type=script&lang=ts&"
export * from "./InquiryMessageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports